export default __webpack_public_path__ + "static/media/lb-dg.7d75c656.webp";